import React, { CSSProperties, useContext } from 'react';
import classes from './CardDragLayer.module.scss';
import { CardOrientationEnum } from '../../../../components/cards/BasePostCard/BasePostCard.view';
import { useDragLayer } from 'react-dnd';
import classNames from 'classnames';
import { Badge } from '../../../../components/containers/Badge';
import { BadgeSizesEnum } from '../../../../constants/badge';
import { DraggableTypesObject } from '../../../../constants/drag-and-drop';
import { Identifier, XYCoord } from 'dnd-core';
import { ScrollContext } from '../../../../providers/ScrollProvider';
import { InstagramGridPostType } from '../../../../models/post';
import { getFirstValidThumbnailUrl } from '../InstragramGridHelper';

export type CardDragLayerViewProps = {
  scheduleItems: InstagramGridPostType[];
  isMobile: boolean;
};

export type PostCardDragType = {
  id: string;
  startPosition: number;
  height: number;
  width: number;
  post: InstagramGridPostType;
  orientation: CardOrientationEnum;
  isStacked: boolean;
};

export const CardDragLayerView = (props: CardDragLayerViewProps): JSX.Element => {
  const { getScrollPosition } = useContext(ScrollContext);

  const scrollPos = getScrollPosition();

  const { itemType, item, clientOffset, isDragging } = useDragLayer<
    {
      item: PostCardDragType;
      isDragging: boolean;
      itemType: Identifier | null;
      clientOffset: XYCoord | null;
    },
    PostCardDragType
  >(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    clientOffset: monitor.getClientOffset()
  }));

  if (itemType !== DraggableTypesObject.IG_GRID_CARD || !isDragging || !clientOffset) return <></>;

  const { x, y } = clientOffset;
  const transform = `translate(${x - 70}px, ${y - 100 + scrollPos}px) rotate(+2deg)`;
  const firstValidThumbnailUrl = getFirstValidThumbnailUrl(item.post);

  const layerStyles: CSSProperties = {
    transform
  };

  const mediaWrapperClasses = classNames(classes.MediaWrapper, {
    [classes.MediaWrapperMobile]: props.isMobile
  });

  return (
    <div className={classes.CardDragLayer} style={{ ...layerStyles }}>
      <div className={mediaWrapperClasses}>
        {firstValidThumbnailUrl ? <img src={firstValidThumbnailUrl} alt={''} /> : <></>}
        {item.post?.category && (
          <div className={classes.BadgeWrapper}>
            <Badge color={item.post.category.color} size={BadgeSizesEnum.LARGE} text={item.post.category.name} />
          </div>
        )}
      </div>
    </div>
  );
};
